import { render, staticRenderFns } from "./HomeAnimationNew.vue?vue&type=template&id=fac508b8&scoped=true&lang=pug&"
import script from "./HomeAnimationNew.vue?vue&type=script&lang=js&"
export * from "./HomeAnimationNew.vue?vue&type=script&lang=js&"
import style0 from "./HomeAnimationNew.vue?vue&type=style&index=0&id=fac508b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac508b8",
  null
  
)

export default component.exports